import styled from 'styled-components'

import { Typography } from 'primsell-shared-layer/components/atoms/typography'

interface BadgeContainerProps {
  backgroundColor?: string
}

interface StatusTextProps {
  textcolor?: string
}

export const BadgeContainer = styled.div<BadgeContainerProps>`
  display: inline-flex;
  padding: 3px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: ${({ backgroundColor }) => backgroundColor};
`

export const StatusText = styled(Typography)<StatusTextProps>`
  color: ${({ textcolor }) => textcolor};
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
`
